export default __webpack_public_path__ + "static/media/CardIconFaded.3b392086.svg";